import { render } from "./box.vue?vue&type=template&id=2fc62fe7"
import script from "./box.vue?vue&type=script&lang=js"
export * from "./box.vue?vue&type=script&lang=js"

import "./box.vue?vue&type=style&index=0&id=2fc62fe7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__